import React from 'react'
import styled from 'styled-components'

import Icon from 'pages/shared/Alert/Icon'
import UnitSpecification from 'pages/shared/Alert/UnitSpecification'

import { alertCodeDisplayValue } from 'helpers/alerts'
import { longDateTimeWithSeconds } from 'helpers/formatters'

import { color } from 'styles/colors'

import { Alert } from 'types/Alert'

interface Header {
  alert: Omit<Alert, 'problems' | 'possibleCauses' | 'additionalInfo'>
}

const Header = ({ alert }: Header) => {
  const { severity, description, code, status, unitType = null, serialId = null, zoneId = null, zoneName = null, occurredAt } = alert

  return (
    <S.Header>
      <S.Title>
        <Icon
          severity={severity}
          size={32}
          className={`icon-${severity}-alert`}
        />
        <div>
          <S.DescriptionArea>
            <S.Description>{description || '--'}</S.Description>
          </S.DescriptionArea>
          <S.Code>{alertCodeDisplayValue(code)}</S.Code>
        </div>
      </S.Title>
      <S.AlertInfo>
        <S.Status>{status === 'new' ? 'occurred' : status}
          <S.OccurredAt>{longDateTimeWithSeconds(occurredAt)}</S.OccurredAt>
        </S.Status>
        <UnitSpecification {...{ unitType, serialId, zoneId, zoneName }} />
      </S.AlertInfo>
    </S.Header>
  )
}

export default Header

const S = {
  Header: styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
  `,
  Title: styled.div`
    width: 70%;
    min-width: 230px;
    display: flex;
    text-align: left;
  `,
  DescriptionArea: styled.div`
    display: flex;
    align-items: center;
    padding-right: 20px;
  `,
  Description: styled.div`
    color: ${color('primaryText')};
    font-size: 24px;
    line-height: 1em;
    font-weight: 600;
    padding-left: 20px;
  `,
  Code: styled.span`
    color: ${color('secondaryText')};
    padding-left: 20px;
    text-align: left;
    font-size: 20px;
  `,
  AlertInfo: styled.div`
    width: 200px;
    display: inline-block;
    margin-left: 10px;
  `,
  Status: styled.div`
    font-size: 16px;
    color: ${color('secondaryText')};
    font-weight: 600;
    text-transform:uppercase;
    text-align: right;
  `,
  OccurredAt: styled.div`
    color: ${color('primaryText')};
    display: block;
    font-size: 12px;
    font-weight: 600;
  `
}
